import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';

const AlertDeleteUser = () => {
    const [loading, setLoading] = useState(false);
    const { dispatch, deletedUser } = useConfig();
    const { setNotify } = useTheme();
  
    const handleClose = () => dispatch({ type: 'deletedUser', payload: null });

    const confirm = async () => {
        setLoading(true);
        const server_response = await ajaxConfig.deleteUser({ username: deletedUser.username });
        setLoading(false);
        if (server_response.status === "OK") {
            setNotify(<Notification type='success' message={server_response.message} />);
        } else {
            setNotify(<Notification type='danger' message={server_response.message} />);
        }
        dispatch({ type: 'deletedUser', payload: null });
    };

    return (
        <BsModal
            show={deletedUser}
            onClose={handleClose}
            title="Delete User"
            footer={
                <div className="d-flex justify-content-end w-100" style={{ gap: '12px' }}>
                    {loading ? (
                        <ActivityLoader />
                    ) : (
                        <>
                            <button className="btn btn-modern-secondary" onClick={handleClose}>
                                Cancel
                            </button>
                            {deletedUser && (
                                <button className="btn btn-modern-danger" onClick={confirm}>
                                    Confirm Delete
                                </button>
                            )}
                        </>
                    )}
                </div>
            }
        >
            {deletedUser && (
                <div className="text-center py-4">
                    <div className="delete-icon-wrapper">
                        <i className="fa-regular fa-circle-question"></i>
                    </div>
                    
                    <h5 className="delete-title">
                        Confirm deletion for 
                        <span className="user-highlight">{deletedUser.username}</span>
                    </h5>

                    <div className="delete-note-box">
                        <p className="mb-0">
                            <strong>Note:</strong> To preserve audit logs, users with existing entries will be <b>deactivated</b> rather than permanently removed.
                        </p>
                    </div>
                </div>
            )}
        </BsModal>
    );
};

export default AlertDeleteUser;